import { useState, useEffect } from 'react';
import { getAccessToken } from '../utils/auth';

function Modelconnectors({ onEdit }) {
  const [modelconnectors, setModelconnectors] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'modified', direction: 'desc' });

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${(date.getMonth()+1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

  const handleSort = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ key, direction });
  };

  const sortedModelconnectors = [...modelconnectors].sort((a, b) => {
    if (!sortConfig.key) return 0;
    
    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];
    
    if (sortConfig.key === 'modified') {
      aValue = new Date(aValue).getTime();
      bValue = new Date(bValue).getTime();
    } else if (typeof aValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }
    
    if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  useEffect(() => {
    const fetchModelconnectors = async () => {
      const token = await getAccessToken();
      if (token) {
        fetch(`${process.env.REACT_APP_ORCHESTRATOR_ENDPOINT}/modelconnector`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
          .then(response => response.json())
          .then(data => setModelconnectors(data))
          .catch(error => console.error('Error fetching model connectors:', error));
      }
    };
    fetchModelconnectors();
  }, []);

  return (
    <div>
      <div className="header-layout">
        <h2 className="header-title">Model Connectors</h2>
        <button className="btn-add" onClick={() => onEdit && onEdit('00000000000000000000000000000000')}>
          Add Connector
        </button>
      </div>
      <table className="data-table modelconnectors-table">
        <thead>
          <tr>
            <th onClick={() => handleSort('provider')} style={{ cursor: 'pointer' }}>Provider</th>
            <th onClick={() => handleSort('display_name')} style={{ cursor: 'pointer' }}>Name</th>
            <th onClick={() => handleSort('description')} style={{ cursor: 'pointer' }}>Description</th>
            <th onClick={() => handleSort('is_active')} style={{ cursor: 'pointer' }}>Active</th>
            <th onClick={() => handleSort('modified')} style={{ cursor: 'pointer' }}>Modified</th>
          </tr>
        </thead>
        <tbody>
          {sortedModelconnectors.map((mc, index) => (
            <tr key={index} onClick={() => onEdit && onEdit(mc.id)} style={{ cursor: 'pointer' }}>
              <td data-column="provider"><img src={`/media/${(mc.provider || 'unset').toLowerCase()}-icon.png`} alt={mc.provider || 'unset'} style={{ width: '24px', height: '24px' }} /></td>
              <td data-column="display_name">{mc.display_name}</td>
              <td data-column="description" title={mc.description}>{mc.description}</td>
              <td data-column="active">{mc.is_active ? 'Yes' : 'No'}</td>
              <td data-column="modified">{formatDate(mc.modified)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Modelconnectors;
